import { createSlice, PayloadAction, Dispatch } from '@reduxjs/toolkit';
import { ApiError } from 'models/errors/ApiError';
import * as contractService from 'services/contractService/contractService';
import type { RootState } from 'store';
import { displayApiError } from 'store/globalErrorState/globalErrorState';
import { ContractTypes } from 'utils/constants';

export type DocumentState = {
  isLoading?: boolean;
  termsOfUseDocumentUrl: string;
  error: ApiError | null;
};

export const defaultDocumentState: DocumentState = {
  isLoading: true,
  termsOfUseDocumentUrl: '',
  error: null
};

export const documentSlice = createSlice({
  name: 'document',
  initialState: defaultDocumentState,
  reducers: {
    getDocumentState: (state) => {
      state.isLoading = true;
    },
    getDocumentStateSuccess: (
      state,
      action: PayloadAction<{
        termsOfUseDocumentUrl: string;
      }>
    ) => {
      const { termsOfUseDocumentUrl } = action.payload;
      state.termsOfUseDocumentUrl = termsOfUseDocumentUrl;
      state.isLoading = false;
    },
    getDocumentStateFailure: (state, action: PayloadAction<ApiError>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetDocumentState() {
      return defaultDocumentState;
    }
  }
});

// Export actions
export const {
  getDocumentState,
  getDocumentStateSuccess,
  getDocumentStateFailure,
  resetDocumentState
} = documentSlice.actions;

// Export reducer
export const documentReducer = documentSlice.reducer;

// Export selector
export const documentSelector = (state: RootState) => state.document;

// Export thunks
export function fetchDocumentState(
  languageCode = 'en',
  languageRegionCode?: string
) {
  return async (dispatch: Dispatch) => {
    dispatch(getDocumentState());
    try {
      const termsOfUseDocumentUrl =
        await contractService.getContractDocumentUrl(
          ContractTypes.TermsOfUse,
          languageCode,
          languageRegionCode
        );

      dispatch(getDocumentStateSuccess({ termsOfUseDocumentUrl }));
    } catch (e: any) {
      dispatch(getDocumentStateFailure(e));
      dispatch(displayApiError(e));
    }
  };
}
